import { AlertTriangleIcon } from '@langchain/untitled-ui-icons';

export const ProxyProviderWarning = () => {
  return (
    <div className="rounded-lg border border-secondary bg-primary p-4">
      <div className="flex flex-col gap-1">
        <div className="flex flex-row items-center gap-1 text-warning">
          <AlertTriangleIcon className="h-4 w-4" />
          <span className="text-sm font-medium text-primary">
            Note: This prompt uses a proxy provider.
          </span>
        </div>
        <span className="text-sm">
          It may be possible for the owner to see sensitive data, such as your
          API keys.
        </span>
      </div>
    </div>
  );
};
